import { connect } from 'react-redux';
import { selectUserCurrencyCode } from '@noths/polaris-client-user-configuration';

import { Placement } from 'src/constants/recommendations';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct, selectProductPartner } from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { PartnerStorefront } from '../components';
import {
  actions,
  contactPartnerSubmit,
  ContactPartnerSubmitPayload,
  RelatedProductClickPayload,
  selectContactFormServerErrors,
} from '../modules';
import {
  FieldValidationErrorPayload,
  PartnerProductCardsVisiblePayload,
  PartnerStorefrontLinkClickPayload,
} from '../tracking/events';

const mapStateToProps = (state: ReduxApplicationState) => ({
  product: selectProduct(state),
  similarProducts: state.richRelevance[Placement.SameSeller].products,
  partner: selectProductPartner(state),
  currency: selectUserCurrencyCode(state) ?? 'GBP',
  messageSentSuccessfully: state.partnerStorefront.messageSent,
  contactFormServerErrors: selectContactFormServerErrors(state),
  isContactPartnerModalOpen: state.partnerStorefront.isContactPartnerModalOpen,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onContactPartnerSubmit: (payload: ContactPartnerSubmitPayload) =>
    dispatch(contactPartnerSubmit(payload)),
  onContactPartnerSubmitError: (payload: FieldValidationErrorPayload) =>
    dispatch(actions.contactSellerFieldValidationError(payload)),
  onPartnerProductCardVisible: (payload: PartnerProductCardsVisiblePayload) =>
    dispatch(actions.partnerProductCardsVisible(payload)),
  openContactPartnerModal: () => dispatch(actions.openContactPartnerModal()),
  closeContactPartnerModal: () => dispatch(actions.closeContactPartnerModal()),
  onPartnerStorefrontLinkClick: (payload: PartnerStorefrontLinkClickPayload) =>
    dispatch(actions.onPartnerStorefrontLinkClick(payload)),
  onRelatedProductClick: (payload: RelatedProductClickPayload) =>
    dispatch(actions.onRelatedProductClick(payload)),
});

export const PartnerStorefrontContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PartnerStorefront);
